import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.usuario.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.usuario.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}

export const ActionDeletar = ({dispatch},payload)=>{
    return serves.usuario.delete(payload).then(res => {
       
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.usuario.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.usuario.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCadastroPermissao = ({dispatch},payload)=>{
    return serves.usuario.permissao(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}


